import React from 'react';
import Anchor from '../../objects/Anchor'
import moment from 'moment';

const EventCard = props => {

    const {image, title, date, location, uid} = props.eventsData;

    // Image will always be the same and not dynamic
    const image2 = '/images/icons-new/logo-single-small.png';
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }

    return (
        <div className={`col-12 ${card} base-card event-card ${clever}`} key={uid}>
            <Anchor path={`/events/${uid}`} anchorClass={'card-inner'} target internal>
                <div className="theme-event-head" data-after-content={moment(date).format('ddd')} >
                    <div className="hexagon">
                        <div className="hexagon-in1">
                            <div className="hexagon-in2"
                                 style ={ { backgroundImage: `url(${image})` } }></div>
                        </div>
                    </div>
                    <div className="logo-image"
                         style ={ { backgroundImage: `url(${image2})` } }></div>
                </div>
                <div className="theme-event-body">
                    <h3 className="heading-three">{title}</h3>
                    <div className="body-foot">
                        <div className="card-date">
                            <img src="/images/icons-new/calendar.svg" alt="eye icon" className="foot-img" />
                            <p className="body-copy">{date}</p>
                        </div>
                        <div className="card-location">

                            <img src="/images/icons-new/location.svg" alt="Location icon" className="foot-img" />
                            <p className="body-copy">{location}</p>
                        </div>
                    </div>
                    <span className="theme-button">View event</span>
                </div>
            </Anchor>
        </div>
    );

};

export default EventCard;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/EventsCard.js